// https://github.com/sindresorhus/query-string
import queryString from 'query-string';

/*
 * Returns an object parsed from the current state of the location.search in the URL
 */
export default queryString.parse(window.location.search);